import { CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM } from 'App/utils/Collections';
import { FT_DATE, FT_LIST, FT_SINGLE, FT_CONDITION_GROUP } from '../FilterTypes';
import {
  loadSocialMediaProductTypes,
  loadSocialMediaApplications,
  loadSocialMediaIngredients,
  loadSocialMediaEffects,
  loadSocialMediaNewLaunches,
  loadSocialMediaLocations,
} from './loaders';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 2,
  },
};

const SPLITTABLE_HINT = 'You can type multiple values separated by comma, semicolon, or space.';

export default {
  category: CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM,
  filters: [
    {
      id: 'type',
      isSingle: true,
      label: 'Type',
      type: FT_LIST,
      group: groups.general,
      multiValues: false,
      getListItems: () => [
        {
          id: 'post',
          name: 'Post',
        },
        {
          id: 'reel',
          name: 'Reel',
        },
      ],
    },
    {
      id: 'region',
      label: 'Countries',
      group: groups.general,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose country',
      fieldConf: {
        // searcher: loadSocialMediaLocations,
        items: loadSocialMediaLocations,
      },
      isSocialMedia: true,
    },
    {
      id: 'product_types.id',
      label: 'Product types',
      group: groups.general,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose product type',
      fieldConf: {
        searcher: async (term) => {
          return await loadSocialMediaProductTypes(term);
        },
        items: async () => {
          return await loadSocialMediaProductTypes();
        },
      },
      isSocialMedia: true,
    },
    {
      id: 'applications.id',
      label: 'Applications',
      group: groups.general,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose application',
      fieldConf: {
        searcher: async (term) => {
          return await loadSocialMediaApplications(term);
        },
        items: async () => {
          return await loadSocialMediaApplications();
        },
      },
      isSocialMedia: true,
    },
    {
      id: 'ingredients.id',
      label: 'Ingredients',
      group: groups.general,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose ingredient',
      fieldConf: {
        searcher: async (term) => {
          return await loadSocialMediaIngredients(term);
        },
        items: async () => {
          return await loadSocialMediaIngredients();
        },
      },
      isSocialMedia: true,
    },
    {
      id: 'effects.id',
      label: 'Effects',
      group: groups.general,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose effect',
      fieldConf: {
        searcher: async (term) => {
          return await loadSocialMediaEffects(term);
        },
        items: async () => {
          return await loadSocialMediaEffects();
        },
      },
      isSocialMedia: true,
    },
    {
      id: 'new_launches.id',
      label: 'New Launches',
      group: groups.general,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose new launch',
      fieldConf: {
        searcher: async (term) => {
          return await loadSocialMediaNewLaunches(term);
        },
        items: async () => {
          return await loadSocialMediaNewLaunches();
        },
      },
      isSocialMedia: true,
    },
    {
      id: 'published_date',
      label: 'Published Date',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'hashtag',
      label: 'Hashtags',
      type: FT_SINGLE,
      group: groups.general,
      splittable: true,
      hint: SPLITTABLE_HINT,
    },
    {
      id: 'mention',
      label: 'Mentions',
      type: FT_SINGLE,
      group: groups.general,
      splittable: true,
      hint: SPLITTABLE_HINT,
    },
    {
      id: 'source',
      isSingle: true,
      label: 'Source',
      type: FT_LIST,
      group: groups.general,
      multiValues: false,
      getListItems: () => [
        {
          id: 'google',
          name: 'Google',
        },
        {
          id: 'apify',
          name: 'Apify',
        },
        {
          id: 'google + apify',
          name: 'Google + Apify',
        },
      ],
    },
    {
      id: 'draft',
      isSingle: true,
      label: 'Status',
      group: groups.general,
      type: FT_LIST,
      multiValues: false,
      getListItems: () => [
        { id: 'true', name: 'Draft' },
        { id: 'false', name: 'Published' },
      ],
    },
  ],
  searchBarProp: 'complex_name',
};
